import { createContext, useContext, useEffect, useState } from "react";
import { strings } from "@/i18n/strings";

export const SUPPORTED_LANGS = ["ar", "en"];
export const RTL_LANGS = ["ar"];
export const LANG_NAMES = { ar: "العربية", en: "English" };

const LangCtx = createContext({ lang: "ar", t: (k) => k, toggle: () => {} });

export function LangProvider({ children }) {
  const [lang, setLang] = useState("ar");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const setLangForced = (next) => {
    if (!SUPPORTED_LANGS.includes(next)) return;
    setLang(next);
  };

  const toggle = () => setLangForced(lang === "ar" ? "en" : "ar");

  const t = (key) => {
    const read = (root) => key.split(".").reduce((o, p) => (o != null ? o[p] : undefined), root);
    const val = read(strings[lang]);
    if (val !== undefined) return val;
    const fallback = read(strings.en);
    return fallback !== undefined ? fallback : key;
  };

  return (
    <LangCtx.Provider value={{ lang, t, toggle, setLang: setLangForced, setLangForced }}>
      {children}
    </LangCtx.Provider>
  );
}

export const useLang = () => useContext(LangCtx);
